import React from 'react';
import PropTypes from 'prop-types';
import { Collapsible, CollapsibleContent, CollapsibleHeader } from '../../../../../components/Collapsible';
import { FilterLength, FilterLengthForm } from '../../Filter';
import { customUomPropType } from '../FilterHelpers/FilterPropTypes';
import { useCollapsibleState } from '../FilterHelpers/useSRPFilters';

const CollapsibleLength = ({ facetConfig, label, position, customUom, cookies, min, max, handleDataChange, isThreeColumnLayout }) => {
  const { isEnabled, isOpen } = useCollapsibleState('length', facetConfig);
  if (!isEnabled) {
    return null;
  }
  return (
    <CollapsibleContent initialState={isOpen}>
      <CollapsibleHeader priority={0}>{label}</CollapsibleHeader>
      <Collapsible>
        {position === 'desktop' ? (
          <FilterLengthForm
            customUom={customUom}
            cookies={cookies}
            min={min}
            max={max}
            handleDataChange={handleDataChange}
          />
        ) : (
          <FilterLength
            customUom={customUom}
            cookies={cookies}
            min={length.min}
            max={length.max}
            isThreeColumnLayout={isThreeColumnLayout}
            id="filter-length"
            handleDataChange={handleDataChange}
            position={position}
          />
        )}
      </Collapsible>
    </CollapsibleContent>
  );
};

CollapsibleLength.propTypes = {
  context: PropTypes.object,
  facetConfig: PropTypes.array,
  label: PropTypes.string,
  position: PropTypes.string,
  customUom: customUomPropType,
  cookies: PropTypes.object,
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleDataChange: PropTypes.func,
  isThreeColumnLayout: PropTypes.bool,
};
export { CollapsibleLength };
